import PlayerWrapper from './player-wrapper';


export default class DesktopPlayer extends React.Component {

  static propTypes = _.omit(PlayerWrapper.propTypes, 'mobileMode');

  render() {
    const props = _.omit(this.props,
      'mobileMode',
    );

    return (
      <PlayerWrapper {...props}
                     mobileMode={false} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/widget/components/players/desktop-player.js